import { useApi } from '@repo-level/core-front';
import { assignMission } from 'api/missions';

export const useAssignMission = () => {
  const [requestAssignMission, { error, pending, data }] =
    useApi(assignMission);

  return {
    requestAssignMission,
    assignMissionError: error,
    assignMissionPending: pending,
    assignMissionData: data,
  };
};
